// extracted by mini-css-extract-plugin
export default {"link":"HeaderLogo_link__k50Oy","linkImage":"HeaderLogo_linkImage__hp3H+","linkText":"HeaderLogo_linkText__Baz9J"};